// extracted by mini-css-extract-plugin
export default {"waitContentContainer":"LoadingScreen_waitContentContainer__f2vCa","createButton":"LoadingScreen_createButton__idGCl","line":"LoadingScreen_line__ZBCNF"};